import { useState } from "react";
import { message } from "antd";
import idiomaServices from "./../../../services/alumnos/idiomaServices"
import { useEffect } from "react";

const useIdioma = (inicialData = []) => {
    const [idiomas, setIdiomas] = useState([]);
    const [crearIdioma, setCrearIdioma] = useState(false);
    const [editingIdioma, setEditingIdioma] = useState({});
    const [catalogos, setCatalogos] = useState([]);
    const [loading, setLoading] = useState(false);

    // función para obtener los idiomas
    const getIdiomaMe = async () => {
        setLoading(true);
        const response = await idiomaServices.getIdiomaMe();
        setLoading(false);
        setIdiomas(response.data);
    };

    // Funcion para obtener los tipos de idioma
    const getCatalogos = async () => {
        setLoading(true);
        const response = await idiomaServices.getCatalogos();
        setLoading(false);
        setCatalogos(response.data);
    };

    // Crear o editar idioma
    const onSave = async (data) => {
        
        setLoading(true);
        const response = data?.id_idioma
            ? await idiomaServices.editIdiomaMe(data)
            : await idiomaServices.createIdiomaMe(data);
        setLoading(false);

        if (!response.success)  return false;

        message.success("Guardado correctamente");
        await getIdiomaMe();

        setCrearIdioma(false);
        setEditingIdioma({});

        return true;
    };
    const onCancel = () => {
        setEditingIdioma({});
        setCrearIdioma(false);
    };

    // Funcion para crear un idioma
    const onNuevoIdioma = async () => {
        setCrearIdioma(true);
    }

    // Funcion para editar un idioma
    const editarIdioma = async (data) => {
        setEditingIdioma(data);
    }


    // Funcion para eliminar un idioma
    const deleteIdIdiomaMe = async (id) => {
        const response = await idiomaServices.deleteIdiomaMe(id);
        if (response.success) {
            message.success("Eliminado correctamente");
            await getIdiomaMe();
        }
    };


    useEffect(() => {
        // Cargar datos al montar el componente 
        getCatalogos();
    }, []);

    useEffect(() => {
        // Si inicialData cambia, actualizar idiomas
        setIdiomas(inicialData);
    }, [inicialData]);

    return { 
        idiomas,
        crearIdioma,
        editingIdioma, 
        catalogos,
        loading,
        onNuevoIdioma,
        onSave,
        editarIdioma,
        onCancel,
        deleteIdIdiomaMe
    };


}

export default useIdioma;